import { IActivityScheduleSessionBlockBase } from '../../models/activities';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IListActivityScheduleSessionBlocksServiceProps {
  activityId: string;
  fromDate?: string;
}

export const listActivityScheduleSessionBlocksService = async ({
  activityId,
  fromDate,
}: IListActivityScheduleSessionBlocksServiceProps): Promise<
  IActivityScheduleSessionBlockBase[]
> => {
  const { data } = await jhsfBookingsApi.get(
    `/activities/${activityId}/session-blocks`,
    {
      params: { fromDate },
    },
  );

  return data;
};
